import styled from 'styled-components';

export const StyledObjectTag = styled.div`
    width: 0%;
    height: 0%;
`;